import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CanDeactivateNotification {
  canDeactivate(): boolean {
    return confirm('You have unsaved changes! If you leave, your changes will be lost.');
  }
}
